import { render, staticRenderFns } from "./UserCardItem.vue?vue&type=template&id=962eec20"
import script from "./UserCardItem.vue?vue&type=script&lang=js"
export * from "./UserCardItem.vue?vue&type=script&lang=js"
import style0 from "./UserCardItem.vue?vue&type=style&index=0&id=962eec20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports